import Serials from "../Components/Kays/Serials"
import ApiKeys from "../Components/Kays/ApiKeys"

const Kays =()=>{
    return (
        <div>
            <ApiKeys />
            <Serials />

        </div>
    )
}

export default Kays